export default "__VITE_ASSET__bxJUYAEV__"